import React, { Component, Suspense } from 'react'
import { BrowserRouter, HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import PropTypes from 'prop-types'
import ProtectedRoute from './route/ProtectedRoute'
import ProtectedTrialRoute from './route/ProtectedTrialRoute'
import { Box, Grid, Typography } from '@mui/material'
import { encryptStorage } from 'src/Util'
import SessionTimeOut from './views/pages/login/SessionTimeOut'

const editor_loaderMessage = encryptStorage.getItem('editor_loaderMessage')
const loaderMessage = 'Loading, Please wait....'

const loading = (
  <Box display="flex" width={window.innerWidth} height={window.innerHeight} bgcolor="white">
    <Box m="auto">
      <Grid
        component="div"
        container
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="bookshelf_wrapper">
          <ul className="books_list">
            <li className="book_item first"></li>
            <li className="book_item second"></li>
            <li className="book_item third"></li>
            <li className="book_item fourth"></li>
            <li className="book_item fifth"></li>
            <li className="book_item sixth"></li>
          </ul>
          <div className="shelf"></div>
        </div>
        <Typography variant="body" component="div" style={{ marginTop: '30px' }}>
          {window.location.href.includes('editor') ? editor_loaderMessage : loaderMessage}
        </Typography>
      </Grid>
    </Box>
  </Box>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Forgot = React.lazy(() => import('./views/pages/login/Forgot'))
const SetPassword = React.lazy(() => import('./views/pages/login/SetPassword'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
//const Versions = React.lazy(() => import('./views/pages/page500/Page500'))
const AIEditor = React.lazy(() => import('./views/AIEditor/AIEditor'))
const Editor = React.lazy(() => import('./views/Editor/AppEditor'))

const TrialLogin = React.lazy(() => import('./views/pages/login/TrialLogin'))
const AiCheck = React.lazy(() => import('./views/AiCheck/AiCheckClone'))

class App extends Component {
  render() {
    return (
      <>
        <HashRouter>
          <SessionTimeOut />

          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route exact path="/logout" name="Login Page" element={<Login />} />
              <Route exact path="/forgot" name="Forgot Password Page" element={<Forgot />} />
              <Route
                exact
                path="/forgetinvitation"
                name="Create New Password"
                element={<SetPassword type="forgot" />}
              />
              <Route
                exact
                path="/userinvitation"
                name="Create New Password"
                element={<SetPassword type="create" />}
              />

              <Route exact path="/trial" name="Trial Login Page" element={<TrialLogin />} />
              <Route
                exact
                path="/aiCheck"
                name="aiCheck"
                element={
                  <ProtectedTrialRoute>
                    {' '}
                    <AiCheck />{' '}
                  </ProtectedTrialRoute>
                }
              />

              <Route
                exact
                path="/trail_user_verify"
                name="Trial User Verify"
                // element={<TrialLogin type="verify" />}
                element={<AiCheck type="verify" />}
              />

              <Route exact path="/AIEditor/:id" name="AIEditor" element={<AIEditor />} />
              <Route exact path="/editor/:id" name="Editor" element={<Editor />} />

              <Route
                path="*"
                name="Home"
                element={
                  <ProtectedRoute>
                    <DefaultLayout />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Suspense>
        </HashRouter>
      </>
    )
  }
}

// function RequireAuth({ children, redirectTo }) {
//   let isAuthenticated = encryptStorage.getItem('session-details')
//   alert('Check Auth' + isAuthenticated)
//   return isAuthenticated ? children : <Navigate to={redirectTo} />
// }

// RequireAuth.propTypes = {
//   children: PropTypes.object,
//   redirectTo: PropTypes.string,
// }

export default App
